import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, errMsg } from "../lib/api";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { PageLoading } from "../context/AuthContext";
import { Metric } from "../components/Bits";

export default function Admin() {
  const [s, setS] = useState(null);
  useEffect(() => {
    http.get("/admin/stats").then(({ data }) => setS(data));
  }, []);
  if (!s) return <PageLoading />;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-14" data-testid="admin-page">
      <p className="label-mono">Press office</p>
      <h1 className="font-display text-5xl tracking-tight mt-2">Beta at a glance.</h1>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-6 mt-12">
        <Metric label="Authors" value={s.authors} testid="admin-stats-total-authors-metric" />
        <Metric label="Books" value={s.books} testid="admin-stats-books-metric" />
        <Metric label="Published" value={s.published} testid="admin-stats-published-metric" />
        <Metric label="AI generations" value={s.kits_generated} testid="admin-stats-generations-metric" />
        <Metric label="Page views" value={s.page_views} testid="admin-stats-views-metric" />
        <Metric label="Reader sign-ups" value={s.readers} testid="admin-stats-readers-metric" />
      </div>
      <h2 className="font-display text-3xl mt-16">Newest authors</h2>
      <div className="overflow-x-auto">
        <table className="w-full mt-5 text-sm min-w-[560px]" data-testid="admin-authors-table">
          <thead><tr className="label-mono text-left"><th className="py-2">Name</th><th>Email</th><th>Books</th><th className="text-right">Joined</th></tr></thead>
          <tbody>
            {s.recent_authors.map((a) => (
              <tr key={a.email} className="border-t border-[#E5DEC9]">
                <td className="py-3"><Link to={`/a/${a.slug}`} className="font-display text-lg hover:text-[#C84B31]">{a.name}</Link></td>
                <td>{a.email}</td><td className="font-type">{a.books}</td>
                <td className="text-right font-type text-xs text-[#8E8879]">{a.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <WaitlistAdmin />
    </div>
  );
}

async function exportWaitlist() {
  try {
    const res = await http.get("/admin/waitlist.csv", { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "waitlist.csv";
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error(errMsg(e));
  }
}

function WaitlistAdmin() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    http.get("/admin/waitlist").then(({ data }) => setRows(data));
  }, []);
  return (
    <section className="mt-16" data-testid="admin-waitlist">
      <div className="flex items-center justify-between gap-4">
        <h2 className="font-display text-3xl">Waitlist <span className="text-[#8E8879]" data-testid="admin-waitlist-count">{rows.length}</span></h2>
        <button className="btn-secondary !py-2" onClick={exportWaitlist} disabled={!rows.length} data-testid="admin-waitlist-export-button"><Download size={12} /> CSV</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full mt-5 text-sm min-w-[480px]" data-testid="admin-waitlist-table">
          <thead><tr className="label-mono text-left"><th className="py-2">Email</th><th>Here as</th><th className="text-right">Joined</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[#E5DEC9]" data-testid={`admin-waitlist-row-${r.email}`}>
                <td className="py-3">{r.email}</td><td className="font-type text-xs uppercase">{r.role}</td>
                <td className="text-right font-type text-xs text-[#8E8879]">{r.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
